import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';
import { LoanCategory } from '../../../../../../../../../../types/api';

const { loanCategory } = loanFormModel.formField;

class IsLoanCategoryEqualTo implements Rule {
  private category: LoanCategory;

  public setCategory(category: LoanCategory) {
    this.category = category;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const archetype = application[loanCategory.name] as LoanCategory | null;
    return archetype === this.category;
  }
}

export default new IsLoanCategoryEqualTo();
